import {
  ChangeDetectorRef, ChangeDetectionStrategy, Component,
  ViewChild, Inject, Renderer2,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BrandService } from '../brand.service';
import { Router } from '@angular/router';
import { PermissionsService } from '../../permissions/permissions.service';

import * as _ from 'lodash';

import { BaseModalComponent } from '../../modal/_base-modal.component';


@Component({
  moduleId: module.id,
  selector: 'brand-choose-modal',
  templateUrl: 'brand-choose-modal.component.html',
  styleUrls: ['brand-choose-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandChooseModalComponent extends BaseModalComponent {

  brands: Array<any> = [];
  searchValue: string;
  maxBrandsSize: number = 25;

  constructor(
    protected ref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any,
    protected brandService: BrandService,
    protected router: Router,
    protected permissionsService: PermissionsService,
    private _renderer: Renderer2,
  ) {
    super();
  }

  get filteredBrands() {
    if (!this.searchValue) { return this.brands; }
    return _.filter(this.brands, (brand: any) => {
      const searchStr = this.searchValue.toLowerCase();
      // if brand_name or brand_id match the filter
      return (brand.brand_name.toLowerCase().indexOf(searchStr) >= 0) ||
        (brand.brand_id.toLowerCase().indexOf(searchStr) >= 0);
    });
  }

  get brandsSize(): number {
    return _.size(this.brands);
  }

  // public:
  public show() {
    this.brandService.getBrandList()
    .subscribe(brands => {
      this.brands = _.isArray(brands) ? brands : [];
      this.ref.markForCheck();
    });
    super.show();
  }

  public hide() {
    this.brands = [];
    this.searchValue = null;
    super.hide();
  }

  // private:
  onBrandClick(brand: any) {
    this.brandService.changeSelectedBrand(brand);
    this.permissionsService.clearStoredPermissions();
    this.permissionsService.getPermissions()
    .subscribe(permissions => {
      this.router.navigate(['/dashboard']);
      this.hide();
    });
  }

  onRunSearch(value: string) {
    this.searchValue = value;
    this.ref.markForCheck();
  }

  onClearClick() {
    this.searchValue = null;
    this.ref.markForCheck();
  }

  onCloseModal() {
    this.hide();
  }
}
